import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export const CUSTOM_ATTRIBUTE_FONT_WEIGHT = 'data-0';
export const CUSTOM_ATTRIBUTE_TEXT_TRANSFORM = 'data-1';

export default function MUITypography(theme: Theme) /* : Components['MuiTypography'] */ {
  return {
    defaultProps: {
      variant: 'body1',
      color: 'inherit',
      variantMapping: {
        h1: 'div',
        h2: 'div',
        h3: 'div',
        h4: 'div',
        h4Alt: 'div',
        h5: 'div',
        h6: 'div',
        h6Alt: 'div',
        subtitle1: 'div',
        subtitle2: 'div',
        body1: 'span',
        body2: 'span',
        caption: 'span',
        captionSmall: 'span',
        captionXSmall: 'span',
        overline: 'span',
        inherit: 'span',
      },
    },
    variants: [
      ...[100, 200, 300, 400, 500, 600, 700, 800, 900].map((fontWeight) => ({
        props: { [CUSTOM_ATTRIBUTE_FONT_WEIGHT]: fontWeight },
        style: {
          fontWeight,
        },
      })),
      ...['capitalize', 'uppercase', 'lowercase'].map((textTransform) => ({
        props: { [CUSTOM_ATTRIBUTE_TEXT_TRANSFORM]: textTransform },
        style: {
          textTransform,
        },
      })),
    ],
    styleOverrides: {
      paragraph: {
        marginBottom: theme.spacing(2),
      },
      gutterBottom: {
        marginBottom: theme.spacing(1),
      },
    },
    // variants: [],
  };
}
